export function listToArray(list: string) {
  // Split list string by the following: [ (blank space) ,(comma) ;(semi-colon) \r(carriage return) \n(new line) \t(tab)]
  return list
    .split(/[ |,|;|\r|\n|\t]/g)
    .map(string => string.trim())
    .filter(string => string)
}
